import { AfterViewInit, AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectFeatures, selectMakes, selectModels, selectKeepOffer, selectVersions } from 'src/app/common/store/state/app.state';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData, CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData, ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { KeepBasicData } from '../../constants/keep-basic-data';
import { KeepOffer } from '../../models/keep-offer.model';
import { MatInputModule } from '@angular/material/input';




@Component({
    selector: 'keep-offer-dialog',
    templateUrl: './keep-offer-dialog.component.html',
    styleUrls: ['./keep-offer-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSelectModule]
})
export class KeepOfferDialogComponent implements OnInit, AfterViewInit, AfterViewChecked{
  
    formMessage = "";
    isNewOffer: boolean = false;
    isNewCar: boolean = false;

    keepOffer$ : Observable<KeepOffer | undefined>;
    keepOffer: KeepOffer = new KeepOffer();

    carBodyTypes = CarBasicData.bodyTypes;
    makes: string[];  
    //carModels: string[];
    makes$: Observable<CarMake[]>;
    models$: Observable<CarModel[]>;
    versions$: Observable<CarVersion[]>;

    features$: Observable<CarFeature[]>;

    selectedMake: CarMake = new CarMake('', '', 0);
    selectedModel: CarModel = new CarModel('', '');
    selectedVersion: CarVersion = new CarVersion('', '');
    selectedEngine: CarEngine = new CarEngine('', '');

    citiesBD: string [] = [];
    carGearBoxes = CarBasicData.gearboxes;
    carFuels = CarBasicData.fuelTypes;

    servicesTypes = CommonBasicData.serviceTypes;
    jobCategoriesBD = KeepBasicData.carJobCategories;

    ServiceType= ServiceType
    allMakes = CarBasicData.getMakesBD();

    countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;
    carYearsBD: number[] = AppFunctions.getCarYearsBD();

    CarBusinessLine = CarBusinessLine

  constructor(
    private store: Store,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<KeepOfferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ObjectData,
        ) {
        this.makes = CarBasicData.getMakesBD();
        this.citiesBD = GeneralBasicData.getAllCities([this.keepOffer.country]);

        this.makes$ = this.store.select(selectMakes);
        this.models$ = this.store.select(selectModels);
        this.versions$ = this.store.select(selectVersions);   
        
        this.features$ = this.store.select(selectFeatures);

        this.keepOffer$ = store.select(selectKeepOffer(data.objectSource, data.offerId)); 
    }
  
  ngOnInit(): void {

    console.log('heyyyyyyyy ')
    console.log(this.data)

    this.isNewOffer = (this.data.offerId === "");
    this.isNewCar = (this.data.carId === "");
    
    /*
    if (this.isNewCar) {
      //console.log(this.data)

      this.store.dispatch(CarRefActions.makesFetchSubmit( {}));
      this.store.dispatch(CarRefActions.featuresFetchSubmit( {}));

       

      this.selectedMake.id = +this.keepOffer.makeId;
      this.selectedMake.name = this.keepOffer.make;

      this.selectedModel.id = +this.keepOffer.modelId;
      this.selectedModel.name = this.keepOffer.model;

      this.selectedVersion.id = +this.keepOffer.versionId;
      this.selectedVersion.name = this.keepOffer.version;

      this.selectedEngine.id = +this.keepOffer.engineId;
      this.selectedEngine.name = this.keepOffer.engine;
      
      //this.selectedEngine = this.selectedVersion.engines.filter(eng => eng.id === +this.data.engineId)[0];

      this.makes$.pipe(
        take(2)
        ).subscribe(
          (makes: CarMake[]) => {
            this.selectedMake = makes.filter(make => make.id === this.keepOffer.makeId)[0];
            this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [this.selectedMake.id] }));
            console.log('helloooo 2 '+ this.selectedMake)
          }
        );
  
        this.models$.pipe(
          take(3)
          ).subscribe(
            (models: CarModel[]) => {
              //this.selectedModel = new CarModel('', '');
              this.selectedModel = models.filter(model => model.id === this.keepOffer.modelId)[0];
              console.log(this.selectedModel);
              this.store.dispatch(CarRefActions.versionsFetchSubmit( {modelIds: [this.selectedModel.id]}));
              //console.log(this.selectedModel);
            }
          );
  
        this.versions$.pipe(
          take(4)
          ).subscribe(
            (versions: CarVersion[]) => {
              //this.selectedVersion = new CarVersion('', '');
              this.selectedVersion = versions.filter(version => version.id === this.keepOffer.versionId)[0];
              //this.store.dispatch(CarRefActions.enginesFetchAllSubmit());
              //console.log(this.selectedMake);
            }
          );
    }
    */

    this.keepOffer$.subscribe(
            (result: KeepOffer | undefined) => {
              if(result == undefined || result == null){
                this.keepOffer = new KeepOffer()
                //this.keepOffer.carId = this.data.carId;
                this.keepOffer.businessLine = this.data.businessLine
              }
              else{
                //this.proposal = Object.assign(new Proposal(), result)
                this.keepOffer = JSON.parse(JSON.stringify(result))
              }
              //this.reply = ""
            }
          );
  } 

  ngAfterViewInit(): void{
    this.updateCitiesBD(this.keepOffer.country)
  }

  ngAfterViewChecked(){

    this.updateCitiesBD(this.keepOffer.country)
    this.cdRef.detectChanges();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  
  getCarModels(mk: string): string[]{
    return CarBasicData.getModelsBD([mk]);
  }

  updateCitiesBD(country: string): void{

    this.citiesBD = GeneralBasicData.getAllCities([country]);
   
  }

  getCountryName(code: string){
    return GeneralBasicData.getCountryByCode(code)!.name;
  }

  getCountry(code: string): Country{
    
    let country: Country = GeneralBasicData.getCountryByCode(code)!;

    if(this.isNewOffer){
      // this.data.buyPrice.currency = country.currency;
      //this.data.rentPrice.currency = country.currency;
    }

    return country;
  }

  getCity(city: string){
    return city;
  }
  /* 
  onMakeChange(make: CarMake){
    //console.log(make);
    this.keepOffer.makeId = make.id;
    this.keepOffer.make = make.name;
    this.keepOffer.model = '';
    this.keepOffer.version = '';
    this.selectedModel = new CarModel('','');
    this.selectedVersion = new CarVersion('','');
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [make.id] } ));
  }

  onModelChange(model: CarModel){
    this.keepOffer.modelId = model.id;
    this.keepOffer.model = model.name;
    this.keepOffer.version = '';
    this.selectedVersion = new CarVersion('','');
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: [model.id] } ));
  }

  onVersionChange(version: CarVersion){
    console.log(version);
    this.keepOffer.version = version.name;
    this.keepOffer.versionId = version.id;
    this.keepOffer.engine = '';
    this.selectedEngine = new CarEngine('','');
    this.keepOffer.gearBox = version.gearBox;
  }

  onEngineChange(engine: CarEngine){
    console.log(engine);
    this.keepOffer.engine = engine.name;
    this.keepOffer.engineId = engine.id;
    this.keepOffer.fuel = engine.fuel;
  }
 */
  submitKeepOffer(){
  
    if(this.keepOffer.offerId === ''){
      console.log('new offer')
      this.store.dispatch(DealerActions.keepOfferNewSubmit({ keepOffer: this.keepOffer, objectSource: this.data.objectSource }));
    }
    else{

      console.log('update offer')
      this.store.dispatch(DealerActions.keepOfferUpdateSubmit({ keepOffer: this.keepOffer, objectSource: this.data.objectSource }));         
    
    }
    this.dialogRef.close();
  }

  dateFormat(dt: string): string{
  
    return AppFunctions.stringToDatetime(dt);
    
  }
}

